<template>
    <div class="content">
        <div class="page_searcher">
            <Searcher :items="config.searchers" @search="getData" ref="searcher"/>
        </div>
        <div v-if="tabs.length>=1">
            <div class="page_block" v-if="!reload">
                <a-tabs v-model="current">
                    <a-tab-pane :tab="m.name" v-for="(m, index) in tabs" :key="index">
                        <div class="page_block_content" v-if="current===index">
                            <h3 v-if="tabs[index].no_chart!=true">{{tabs[index].chart.title}}
                                <ChartTrans v-if="tabs[index].chart.summary && tabs[index].chart.type!='mixin'" :fields="tabs[index].fields" :chart="tabs[index].chart" :datas="tabs[index].datas" v-model="tabs[index].trans_chart"  style="float:right"/>
                                <!-- <Mark :id="$route.query.id" style="float:right" :chart="tabs[index].chart"/> -->
                            </h3>
                            <Chart v-if="tabs[index].no_chart!=true" :datas="tabs[index].trans_chart?tabs[index].trans_chart.data:tabs[index].datas" :fields="tabs[index].fields" :conf="tabs[index].trans_chart?tabs[index].trans_chart.config:tabs[index].chart" :height="400" />
                            <div style="text-align:center" v-if="tabs[index].img">
                                <img :src="tabs[index].img" style="max-width:100%">
                            </div>
                            <a-divider dashed style="margin:20px 0 10px 0" v-if="tabs[index].no_chart!=true && tabs[index].no_table!=true"/>
                            <h3 v-if="tabs[index].no_table!=true">{{tabs[index].no_chart==true?' ':tabs[index].name}}
                                <a-button-group style="float:right; margin:0 0 10px 10px" >
                                    <!-- <Mark style="margin:0 16px 0 0;" v-if="$route.query.proj='mn1'" :table="isMark(tabs[index].datas, tabs[index].fields)" :id="$route.query.id" /> -->
                                    <a-button @click="lockHeader(index)" :type="locks.indexOf(index)>=0?'primary':null"><a-icon type="lock" />{{locks.indexOf(index)>=0?$t("common.cancelFix"):$t("common.fixHead")}}</a-button>
                                    <a-button @click="exportToExcel(index)" v-if="config.downloadForbidden!==true"><a-icon type="download"/>{{$t("common.downloadData")}}</a-button>
                                    <a-button @click="copy(index)" id="copy-btn" v-if="config.downloadForbidden!==true"><a-icon type="copy"/>{{$t("common.copyData")}}</a-button>
                                </a-button-group>
                            </h3>
                            <div  class="page-block-info" v-html="getInfo(tabs[index].infos, undefined, tabs[index].datas)" v-if="tabs[index].infos && tabs[index].infos.text"></div>
                            <DataTable v-if="tabs[index].no_table!=true" :liucun="tabs[index].liucun" :fields="tabs[index].fields" :theads="tabs[index].theads" 
                            :datas="tabs[index].datas" :ref="`datatable_${index}`" :pageSize="config.pageSize" :marks="marks" :color="config.color" :xlen="tabs[index].xlen" :show_index="tabs[index].show_index"/>
                        </div>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>
    </div>
</template>  

<script>
import {ctrlMixin} from '@/utils/ctrlMixin.js'
import Searcher from '@/components/common/search/searcher.vue'
import DataTable from '@/components/common/datatable.vue'
import Chart from '@/components/common/chart/chart.vue'
import Mark from '@/components/common/chart/mark.vue'
import ChartTrans from '@/components/common/chart/chart_trans.vue'
export default {
    mixins: [ctrlMixin],
    components: {
        Searcher,
        DataTable,
        Chart,
        Mark,
        ChartTrans,
    },
    methods: {
        // 获取页面数据
        getData(params) {
            this.loading = true
            this.$service.query(this.queryId, params).then((data)=>{
                let tabs = []
                data.forEach((m)=>{
                    let tab = _.cloneDeep(this.modules[0])
                    let keys = ['fields', 'theads', 'chart', 'img', 'name', 'no_chart', 'no_table', 'infos', 'show_index']
                    Object.keys(m).forEach((key) => {
                        if(keys.indexOf(key) >=0 ) {
                            tab[key] = m[key]
                        }
                    })
                    tab['datas'] = m.datas?m.datas:[]
                    tabs.push(tab)
                })
                this.tabs = tabs
                this.loading = false    
                
                this.reload = true
                this.$nextTick(()=>{
                    this.reload = false
                })
            }).catch((data)=>{
                this.loading = false
            })
        },
    },
    data() {
        return {
            initData: false,
            current:0,
            tabs:[],
            reload: false
        }
    },
}
</script>